import styled from 'styled-components';
import {
  tablet_breakpoint,
  desktop_breakpoint,
  desktop_breakpoint_extended,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const ContactUsStyles = styled.div`
  background-color: ${Colors.accent.grey7.standard};
  font-family: 'acumin-pro', sans-serif;

  .area-header {
    padding: 60px 0 0 0;
  }
  .area-hero {
    .area-info {
      .hero-heading {
        margin-bottom: 2px;
      }
    }
    .breadcrumb {
      margin-bottom: 2px;
    }
  }

  .help-modal {
    padding: 40px;

    h4 {
      text-align: center;
      margin-top: 20px;
      margin-bottom: 20px;
    }

    p {
      color: ${Colors.accent.grey1.standard};
      font-family: 'source-sans-pro', sans-serif;
      font-size: 14px;
      line-height: 1.57;
      margin: 0 0 10px;
      text-align: left;
    }
    a {
      cursor: pointer;
      font-family: 'source-sans-pro', sans-serif;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 1px;
      line-height: 1.14;
      position: absolute;
      right: 34px;
      text-decoration: none;
    }
  }
  h1 {
    background-color: ${Colors.primary.claytonBlue.standard};
    font-family: 'acumin-pro', sans-serif;
    font-size: 40px;
    font-weight: 800;
    margin-bottom: 0;
    padding: 75px 0;
    width: 100%;
  }
  .subheader-container {
    background-color: #ffffff;
  }
  .body-content {
    margin: 0 auto;
  }
  a {
    color: ${Colors.primary.claytonBlue.standard};

    &:hover,
    &:visited {
      color: ${Colors.primary.claytonBlue.standard};
      text-decoration: none;
    }
  }
  h5 {
    line-height: 20px;
    margin-bottom: 10px;
  }
  h6 {
    line-height: 16px;
    margin-bottom: 10px;
    margin-top: 5px;
  }

  .help-container {
    .modal-container {
      width: 95%;
    }
  }

  @media only screen and (min-width: ${tablet_breakpoint}px) {
    .help-container {
      .modal-container {
        width: 45%;
        max-width: 527px;
        min-width: 320px;
      }
    }
  }
  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .help-container {
      .modal-container {
        width: 30%;
        max-width: 527px;
        min-width: 388px;
      }
    }
  }
  @media only screen and (min-width: ${desktop_breakpoint_extended}px) {
    .body-content {
      display: flex;
      justify-content: space-between;
      max-width: 996px; /* 1024px - 30px margin */
    }
  }
`;

export default ContactUsStyles;
